/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import {
    MdPhotoSizeSelectLarge,
    MdPhotoSizeSelectActual,
    MdFastfood,
} from 'react-icons/md';
import ReactLoading from 'react-loading';
// import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import {
    Button,
    // Card,
    Chip,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Slider,
} from '@material-ui/core';

import FormSwitch from '~/components/Form/Switch';
import GalleryView from '~/components/GalleryView';
import LocaleMessage from '~/components/LocaleMessage';
import SimpleDialog from '~/components/SimpleDialog';

// import pluginbot_logo from '~/assets/logo-dark.png';
import pluginbot_logo_white from '~/assets/logo-white.png';
import api from '~/services/pluginbot-api';

import ColorSettings from '../ColorSettings';
import {
    ParameterArea,
    MediaArea,
    PreviewArea,
    Screen,
    AppHeader,
    AppContent,
} from '../styles';
import { Model1 } from './styles';

export default function StandbyPage({
    pageKey,
    pageTitle,
    settings,
    setSettings,
    galleries,
    setToast,
    handleError,
    theme,
}) {
    // const ps_logo = useSelector(state =>
    //     state.settings && state.settings.logo ? state.settings.logo : null
    // );

    const pageSettings = settings[pageKey] || {};
    const mediaSettings = pageSettings.media || {};
    const pageColors = pageSettings.colors || {};

    const colors = [
        {
            id: 'background',
            default: theme.primary,
            value: theme.primary,
            title: 'page.applications.indoor_delivery.form.colors.background',
        },
        {
            id: 'buttons',
            default: '#ffffff',
            value: '#ffffff',
            title: 'page.applications.indoor_delivery.form.colors.buttons',
        },
        {
            id: 'button_text',
            default: '#000000',
            value: '#000000',
            title: 'page.applications.indoor_delivery.form.colors.button_text',
        },
        {
            id: 'button_border',
            default: '#000000',
            value: '#000000',
            title:
                'page.applications.indoor_delivery.form.colors.button_border',
        },
    ];

    const defColors = {};
    colors.forEach(c => {
        const { id: i, default: d } = c;
        defColors[i] = d;
    });

    const targetRef = useRef();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [isLoading, setIsLoading] = useState(false);
    const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [currGallery, setCurrGallery] = useState(null);
    const [refreshedMedia, setRefreshedMedia] = useState(null);

    useEffect(() => {
        if (targetRef.current) {
            setDimensions({
                width: targetRef.current.offsetWidth,
                height: (9.0 / 16.0) * targetRef.current.offsetWidth,
            });
        }
    }, []);

    function setPageSettings(key, val) {
        setSettings([pageKey], {
            ...pageSettings,
            [key]: val,
        });
    }

    async function loadAlbumFiles(_id) {
        if (_id) {
            setIsLoading(true);
            await api
                .get(`albums/${_id}/files`)
                .then(response => {
                    const files = response.data;
                    setFileList(files);
                })
                .catch(error => handleError(error));
            setIsLoading(false);
        } else {
            setFileList([]);
        }
    }

    function loadFile(_id) {
        const file = fileList.find(f => {
            return f.id === _id;
        });
        setRefreshedMedia(file);
    }

    useEffect(() => {
        if (pageSettings.show_image && !currGallery) {
            setCurrGallery(galleries && galleries[0] ? galleries[0].id : null);
        }
    }, [galleries, pageSettings.show_image]);

    useEffect(() => {
        loadAlbumFiles(currGallery);
    }, [currGallery]);

    useEffect(() => {
        return loadFile(mediaSettings.file ? mediaSettings.file.file_id : '');
    }, [fileList, mediaSettings.file]);

    async function onFileUpload(e) {
        const { files } = e.target;
        const data = new FormData();

        setIsLoading(true);

        Array.from(files).forEach(file => {
            data.append('files', file);
        });
        await api
            .post(`albums/${currGallery}/files`, data)
            .then(() => {
                setToast({
                    color: 'success',
                    body: <LocaleMessage msg="message.media_uploaded" />,
                });
                loadAlbumFiles(currGallery);
            })
            .catch(error => handleError(error));
        setIsLoading(false);
    }

    function handleItemClick(event, index) {
        const file = fileList[index];
        const file_url = file.url;
        const f_properties = file_url.split('.');
        const f_format = f_properties[f_properties.length - 1];

        setPageSettings('media', {
            type: 'image',
            gallery_id: currGallery,
            file: {
                file_id: file.id,
                url: file.url,
                image: file.path,
                format: f_format,
            },
        });
        setMediaDialogOpen(false);
    }

    function handleMediaDialogClose() {
        setMediaDialogOpen(false);
    }

    function renderGallery(type) {
        const currGalleryObj = galleries.find(g => {
            return g.id === currGallery;
        });
        return (
            <>
                <FormControl fullWidth>
                    <InputLabel>
                        <LocaleMessage msg="page.applications.telepresence.form.gallery" />
                    </InputLabel>
                    <Select
                        value={currGallery || ''}
                        onChange={event => setCurrGallery(event.target.value)}
                    >
                        {galleries.map(g => (
                            <MenuItem key={g.id} value={g.id}>
                                {!g.editable ? (
                                    <Chip
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        label={
                                            <LocaleMessage msg="message.open_all.short" />
                                        }
                                        style={{ marginRight: '10px' }}
                                    />
                                ) : null}
                                {g.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <div className="sidecard-body" style={{ height: '45vh' }}>
                    {isLoading ? (
                        <div
                            className="mt-5"
                            style={{
                                flex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <ReactLoading
                                type="bars"
                                color="#c8c8c8"
                                height={50}
                                width={50}
                            />
                        </div>
                    ) : (
                        <>
                            {currGalleryObj ? (
                                <GalleryView
                                    media={fileList}
                                    allowNew={
                                        type === 'image' &&
                                        currGalleryObj.editable
                                    }
                                    multiple
                                    fileUpload={e => onFileUpload(e)}
                                    onClick={(e, _id) =>
                                        handleItemClick(e, _id)
                                    }
                                />
                            ) : null}
                        </>
                    )}
                </div>
            </>
        );
    }

    function renderMediaDialog() {
        const g_type = 'image';
        return (
            <SimpleDialog
                open={mediaDialogOpen}
                onClose={() => handleMediaDialogClose()}
                title={
                    <LocaleMessage msg="page.applications.telepresence.form.media" />
                }
                content={renderGallery(g_type)}
            />
        );
    }

    function renderPageModel1() {
        return (
            <Model1
                className="row"
                dimensions={dimensions}
                parameters={pageSettings}
                colors={pageColors}
                defColors={defColors}
            >
                <AppHeader className="row">
                    <div className="header-icon mx-2">
                        {/* <MdKeyboardArrowLeft size={16} /> */}
                    </div>
                    <div className="header-center">
                        <img
                            className="pluginbot-logo"
                            src={pluginbot_logo_white}
                            alt="Pluginbot Logo"
                            title="Pluginbot Logo"
                        />
                    </div>
                    <div className="header-icon mx-2" />
                </AppHeader>
                <AppContent>
                    <div className="body">
                        <div className="img-area p-1 pt-3 text-center">
                            <div className="full-height">
                                <img
                                    className="page-img"
                                    src={
                                        refreshedMedia ? refreshedMedia.url : ''
                                    }
                                    alt="Standby Page Img"
                                    title="Standby Page Img"
                                />
                            </div>
                        </div>
                        <div className="options-area p-3 col-12 row">
                            <div className="col-3 p-1 full-height">
                                <div className="p-1 option">
                                    <div className="option-img mb-1">
                                        <MdFastfood size={42} />
                                    </div>
                                    <span className="option-txt">DELIVERY</span>
                                </div>
                            </div>
                            <div className="col-3 p-1 full-height">
                                <div className="p-1 option">
                                    <div className="option-img mb-1" />
                                    <span className="option-txt">OPT 2</span>
                                </div>
                            </div>
                            <div className="col-3 p-1 full-height">
                                <div className="p-1 option">
                                    <div className="option-img mb-1" />
                                    <span className="option-txt">OPT 3</span>
                                </div>
                            </div>
                            <div className="col-3 p-1 full-height">
                                <div className="p-1 option">
                                    <div className="option-img mb-1" />
                                    <span className="option-txt">OPT 4</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </AppContent>
            </Model1>
        );
    }

    // function renderPageModel2() {
    //     return (
    //         <Model2
    //             className="row"
    //             dimensions={dimensions}
    //             colors={pageColors}
    //         >
    //             <div className="header row">
    //                 <img
    //                     className="pluginbot-logo"
    //                     src={pluginbot_logo_white}
    //                     alt="Pluginbot Logo"
    //                     title="Pluginbot Logo"
    //                 />
    //             </div>
    //             <div className="content row">
    //                 <div className="col-1 icon-area">
    //                     <MdSwapVert size={22} className="mb-3" />
    //                     <MdBatteryFull size={18} className="mb-3" />
    //                     <IoLockClosedSharp size={18} className="mb-3" />
    //                 </div>

    //                 <div className="col-5 img-area">
    //                     {/* <img
    //                         className="robot-img"
    //                         src={robot_img}
    //                         alt="Robot Type"
    //                         title="Robot Type"
    //                     /> */}
    //                     <span className="robot-name">
    //                         [1234] <LocaleMessage msg="label.form.name" />
    //                     </span>
    //                 </div>
    //                 <div className="col-6 options-area p-3">
    //                     {pageSettings.show_logo ? (
    //                         <img
    //                             className="pluginspace-logo"
    //                             src={ps_logo ? ps_logo.url : ''}
    //                             alt="Pluginspace Logo"
    //                             title="Pluginspace Logo"
    //                         />
    //                     ) : null}
    //                     <div className="options">
    //                         <Button
    //                             className="p-1 mb-3"
    //                             fullWidth
    //                             type="submit"
    //                             variant="contained"
    //                             color="primary"
    //                             size="medium"
    //                         >
    //                             <LocaleMessage msg="page.applications.indoor_delivery.form.preview.action" />
    //                             {` 1`}
    //                         </Button>
    //                         <Button
    //                             className="p-1"
    //                             fullWidth
    //                             type="submit"
    //                             variant="contained"
    //                             color="primary"
    //                             size="medium"
    //                         >
    //                             <LocaleMessage msg="page.applications.indoor_delivery.form.preview.action" />
    //                             {` 2`}
    //                         </Button>
    //                     </div>
    //                 </div>
    //             </div>
    //         </Model2>
    //     );
    // }

    function renderPagePreview() {
        return (
            <PreviewArea className="mb-3" ref={targetRef}>
                <Screen dimensions={dimensions} colors={pageColors}>
                    {renderPageModel1()}
                </Screen>
            </PreviewArea>
        );
    }

    function renderColorSelectors() {
        return (
            <div className="mb-5">
                <ColorSettings
                    colors={colors}
                    pageColors={pageColors}
                    setPageColors={c => {
                        setPageSettings('colors', c);
                    }}
                    theme={theme}
                />
            </div>
        );
    }

    function renderParameters() {
        return (
            <div style={{ height: '100%' }}>
                {renderColorSelectors()}

                <div className="col-12">
                    <FormSwitch
                        fullWidth
                        className="mb-3"
                        value={
                            pageSettings.image_buttons
                                ? pageSettings.image_buttons
                                : false
                        }
                        onChange={event =>
                            setPageSettings(
                                'image_buttons',
                                event.target.checked
                            )
                        }
                        label={
                            <LocaleMessage msg="page.applications.indoor_delivery.form.visual.image_buttons" />
                        }
                    />
                </div>

                <div className="col-12 row">
                    <div className="col-6">
                        <FormSwitch
                            fullWidth
                            className="mb-3"
                            value={
                                pageSettings.show_image
                                    ? pageSettings.show_image
                                    : false
                            }
                            onChange={event =>
                                setPageSettings(
                                    'show_image',
                                    event.target.checked
                                )
                            }
                            label={
                                <LocaleMessage msg="page.applications.indoor_delivery.form.visual.show_image" />
                            }
                        />
                        {pageSettings.show_image ? (
                            <>
                                <Button
                                    className="mb-3"
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    fullWidth
                                    onClick={() => setMediaDialogOpen(true)}
                                >
                                    <LocaleMessage msg="label.form.change_image" />
                                </Button>
                            </>
                        ) : null}
                    </div>

                    {pageSettings.show_image ? (
                        <>
                            <MediaArea className="col-md-6 col-12 text-center">
                                <span className="mt-3 mb-3">
                                    <LocaleMessage msg="page.applications.telepresence.form.image_size" />
                                </span>
                                <Grid className="mb-3" container spacing={2}>
                                    <Grid item>
                                        <MdPhotoSizeSelectLarge />
                                    </Grid>
                                    <Grid item xs>
                                        <Slider
                                            min={1}
                                            max={100}
                                            value={
                                                pageSettings &&
                                                pageSettings.media_width
                                                    ? Number(
                                                          pageSettings.media_width
                                                      )
                                                    : 50
                                            }
                                            onChange={(event, newValue) =>
                                                setPageSettings(
                                                    'media_width',
                                                    newValue
                                                )
                                            }
                                            aria-labelledby="continuous-slider"
                                        />
                                    </Grid>
                                    <Grid item>
                                        <MdPhotoSizeSelectActual />
                                    </Grid>
                                </Grid>
                            </MediaArea>
                        </>
                    ) : null}
                </div>
            </div>
        );
    }

    return (
        <ParameterArea className="col-12 row">
            <div className="col-12 p-3 mt-3 mb-3 text-center">
                <LocaleMessage msg={pageTitle} />
            </div>
            {mediaDialogOpen ? renderMediaDialog() : null}
            <div className="col-md-6 col-12 mb-3">{renderParameters()}</div>
            <div className="col-md-6 col-12 mb-3">{renderPagePreview()}</div>
        </ParameterArea>
    );
}

StandbyPage.defaultProps = {
    settings: {},
    galleries: [],
};

StandbyPage.propTypes = {
    settings: PropTypes.object,
    pageKey: PropTypes.string.isRequired,
    pageTitle: PropTypes.string.isRequired,
    setSettings: PropTypes.func.isRequired,
    galleries: PropTypes.array,
    handleError: PropTypes.func.isRequired,
    setToast: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
};
